import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import { downloadFile } from "@/helpers/file-helper";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getFiles(ctx, params) {
    try {
      const response = await api.getFiles(params);
      ctx.commit("getFilesSuccess", {
        files: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async getDownloadFile(ctx, params) {
    try {
      const response = await api.getDownloadFile(params);
      downloadFile(response.data.url, params.file_name);
    } catch (error) {
      throw error;
    }
  }
};

export default actions;
